// 指定图表的配置项和数据
export // 指定图表的配置项和数据
var option = {
  title: {
    text: ''
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: ['今年采购商人数', '去年采购商人数'],
    textStyle: {
      fontSize: 18,
      color: '#fff'
    },
    x: '5%'
  },
  color: ['#274cd5', '#fe6d1b'],
  calculable: true,
  xAxis: [{
    splitLine: {
      show: false,

      color: '#141e34'
      // 隐藏内部线
    },
    type: 'category',
    data: [], // 外部配置数据
    axisLabel: {
      interval: 0,
      rotate: 45,
      textStyle: { // 刻度值的字体样式设置
        color: '#7591d8',
        fontSize: 18
      },
      margin: 20
    }
  }],
  yAxis: [{
    type: 'value',
    axisLabel: {
      interval: 0,
      rotate: 0,
      textStyle: { // 刻度值的字体样式设置
        color: '#7591d8',
        fontSize: 20
      },
      margin: 20
    }
  }],
  series: [{
    name: '2018',
    type: 'bar',
    data: [], // 外部配置数据
    barCategoryGap: 10, // 同个x坐标内的柱状图间距 px
    barGap: 0 // 几个柱状条的宽度

  }, {
    name: '2019',
    type: 'bar',
    data: [] // 外部配置数据
  }]
}
